module.exports = __webpack_public_path__ + "static/media/BabyCourse_Desktop_Main_12.4c3284ac.jpg";